import React, { useEffect, useState, useCallback, useRef } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

import DataTable from "react-data-table-component";
import SupplierConstants from "../../../../common/SupplierConstants";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { getTodaysData } from "../../../../common/Validations";
// import { getMaterialList } from "../../../../redux/feature/customer_app/customerSlice";
// import { useDispatch } from "react-redux";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

const MaterialSelectionModal = React.forwardRef((props, ref) => {
  // const dispatch = useDispatch();

  // let materialData = useSelector((state) => state?.customer?.material?.data);
  // let materialTable = useSelector(
  //   (state) => state?.customer?.material?.pagination,
  // );
  const [disabled, setDisabled] = useState(true);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [allMaterials, setAllMaterials] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // eslint-disable-next-line
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getSelectedData, setSelectedData] = useState([]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const searchableKeys = [
    "materialCode",
    "materialDescription",
    "materialGroup",
    "unit",
    "unitPrice",
    "companyCodeDesc",
    "materialGroupDesc",
    "hsnCode",
  ];

  const handleChangeCat = ({ selectedRows }) => {
    // setSelectedData(selectedRows);
    const updatedSelectedRows = selectedRows.map((row) => ({
      ...row,
      accOnOff: true,
      isShippingEdited: false,
      isPostalEdited: false,
      loadingTruckNo: "",
      deliveryDate: getTodaysData(),
      storageLocation: "Sale",
      storageLocationCode: "SL",
      storageLocationDescription: "Sale",
    }));

    setSelectedData(updatedSelectedRows);

    if (selectedRows.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const handleCategoryChange = useCallback(
    (value) => {
      const category = value?.name || "";
      setSelectedCategory(category);
      setSelectedSubCategory("");

      setSubCategoryData([]);
      if (!category || allMaterials.length === 0) return;

      const uniqueSubCategories = [
        ...new Set(
          allMaterials
            .filter((m) => m.category === category && m.subCategory)
            .map((m) => m.subCategory),
        ),
      ];
      const formattedSubCategories = uniqueSubCategories.map((sub, idx) => ({
        id: idx + 1,
        name: sub,
        code: sub,
        description: sub,
      }));
      setSubCategoryData(formattedSubCategories);
    },
    [allMaterials],
  );

  const handleSubCategoryChange = useCallback((value) => {
    const subCategory = value?.name || "";
    setSelectedSubCategory(subCategory);
  }, []);

  // const loadGetMaterials = async () => {
  //   let obj = {
  //     queryName: "getMaterilMasterList",
  //     rowFilter: {
  //       materialType:  (props.materialType === "SA" || props.materialType === "MAT")? "MAT":"SER",
  //     },
  //   };
  //   await ItemService.getMaterials(obj).then((item) => {
  //     console.log("API response:", item.data);
  //     const expectedType = (props.materialType === "SA" || props.materialType === "MAT") ? "MAT" : "SER";
  //     const filtered = item.data.filter((m) => m.materialType === expectedType);
  //     setAllMaterials(filtered);
  //     // Extract unique categories from filtered data
  //     const uniqueCategories = [...new Set(filtered.map((m) => m.category))];
  //     const formattedCategories = uniqueCategories.map((cat, idx) => ({
  //       id: idx + 1,
  //       name: cat,
  //       code: cat,
  //       description: cat,
  //     }));
  //     setCategoryData(formattedCategories);
  //   });
  // };

  const lastFetchedType = useRef(null);

  const loadGetMaterials = useCallback(async () => {
    // 💡 CACHE CHECK: If materials for this type are already loaded in memory, don't call API again!
    if (
      allMaterials.length > 0 &&
      lastFetchedType.current === props.materialType
    ) {
      return;
    }

    setLoading(true);
    let obj = {
      queryName: "getMaterilMasterList",
      rowFilter: {
        materialType:
          props.materialType === "SA" || props.materialType === "MAT"
            ? "MAT"
            : "SER",
      },
    };
    try {
      await ItemService.getMaterials(obj).then((item) => {
        const rawData = item.data || [];

        const hasMaterialType = rawData.some(
          (m) => m.materialType !== undefined,
        );

        const transformed = rawData.map((m) => ({
          ...m,
          category:
            m.category || m.stockGroup || m.materialGroup || "Uncategorized",
          subCategory:
            m.subCategory || m.stockCode || m.materialSubCategory || "",
          materialType: m.materialType,
        }));

        let filtered = transformed;
        if (hasMaterialType) {
          const expectedType =
            props.materialType === "SA" || props.materialType === "MAT"
              ? "MAT"
              : "SER";
          filtered = transformed.filter((m) => m.materialType === expectedType);
        }

        setAllMaterials(filtered);
        lastFetchedType.current = props.materialType; // 💡 Record last fetched type

        const uniqueCategories = [
          ...new Set(filtered.map((m) => m.category).filter(Boolean)),
        ];
        const formattedCategories = uniqueCategories.map((cat, idx) => ({
          id: idx + 1,
          name: cat,
          code: cat,
          description: cat,
        }));
        setCategoryData(formattedCategories);
      });
    } catch (error) {
      console.error("Error loading materials:", error);
    } finally {
      setLoading(false);
    }
  }, [props.materialType, allMaterials.length]);

  // const loadGetMaterials = useCallback(async () => {
  //   let obj = {
  //     queryName: "getMaterilMasterList",
  //     rowFilter: {
  //       materialType:
  //         props.materialType === "SA" || props.materialType === "MAT"
  //           ? "MAT"
  //           : "SER",
  //     },
  //   };
  //   await ItemService.getMaterials(obj).then((item) => {
  //     const rawData = item.data || [];

  //     // 1. Check if any object has materialType
  //     const hasMaterialType = rawData.some((m) => m.materialType !== undefined);

  //     // 2. Normalise each object: unify category and subCategory fields
  //     const transformed = rawData.map((m) => ({
  //       ...m,
  //       // Normalise category: prefer 'category' then 'stockGroup' then 'materialGroup' then default
  //       category:
  //         m.category || m.stockGroup || m.materialGroup || "Uncategorized",
  //       // Normalise sub‑category: prefer 'subCategory' then 'stockCode' then 'materialSubCategory' then empty string
  //       subCategory:
  //         m.subCategory || m.stockCode || m.materialSubCategory || "",
  //       // Preserve materialType if present, else keep undefined
  //       materialType: m.materialType,
  //     }));

  //     // 3. Apply materialType filter only if the field exists in at least one object
  //     let filtered = transformed;
  //     if (hasMaterialType) {
  //       const expectedType =
  //         props.materialType === "SA" || props.materialType === "MAT"
  //           ? "MAT"
  //           : "SER";
  //       filtered = transformed.filter((m) => m.materialType === expectedType);
  //     }
  //     // else keep all (since we cannot determine the type)

  //     // 4. Store and build category dropdown
  //     setAllMaterials(filtered);

  //     const uniqueCategories = [
  //       ...new Set(filtered.map((m) => m.category).filter(Boolean)),
  //     ];
  //     const formattedCategories = uniqueCategories.map((cat, idx) => ({
  //       id: idx + 1,
  //       name: cat,
  //       code: cat,
  //       description: cat,
  //     }));
  //     setCategoryData(formattedCategories);
  //   });
  // }, [props.materialType]);

  // useEffect(() => {
  //   // setCategoryData(categorySelectionData)
  //   if (props.show) {
  //     loadGetMaterials();
  //   }
  //   // let obj = {
  //   //   queryName: "getMaterilMasterList",
  //   //   page: 1,
  //   //   per_page: 10,
  //   //   rowFilter: {
  //   //     materialType: (props.materialType === "SA" || props.materialType === "MAT") ? "MAT" : "SER",
  //   //   },
  //   // };
  //   // dispatch(getMaterialList(obj));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.show, props.materialType]);

  const isInitialMount = useRef(true);
  const prevShow = useRef(props.show);
  const prevMaterialType = useRef(props.materialType);

  useEffect(() => {
    const isOpening = props.show && !prevShow.current;
    const materialTypeChanged = props.materialType !== prevMaterialType.current;

    if (isInitialMount.current) {
      isInitialMount.current = false;
      // Lazy load: only fetch on initial mount if the modal happens to be open
      if (props.show) {
        loadGetMaterials();
      }
    } else {
      // Fetch if the user just opened the modal, OR if they changed the material type in the parent
      if (isOpening || materialTypeChanged) {
        loadGetMaterials();
      }
    }

    prevShow.current = props.show;
    prevMaterialType.current = props.materialType;
  }, [props.show, props.materialType, loadGetMaterials]);

  // Handle Submit IviteTeamMembers
  const handleSubmit = async () => {
    props.onselectedcatdata(getSelectedData);
    props.onHide();
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const columns = [
    {
      name: "Material",
      selector: (row) => row?.materialDescription,
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-bold text-primary">
            {row?.materialDescription}{" "}
          </p>
          <p className="m-0 p-0 pt-1  ">{row?.materialCode} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "Qty",
      selector: (row) => row.uOM || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-bold text-primary">
            {row?.purchaseQuantity}{" "}
          </p>
          <p className="m-0 p-0 pt-1  ">{row?.unit || row?.uOM} </p>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Rate",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-medium">
            {" "}
            {row?.unitPrice || row?.orderPriceUnit}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "MRP",
      selector: (row) => row.mrPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-medium"> {row?.mrPrice} </p>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "HSN",
      selector: (row) => row.hsnCode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-medium"> {row?.hsnCode || ""} </p>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-medium"> {row?.taxCode || ""} </p>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Company",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-medium"> {row?.companyCodeDesc || ""} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
  ];
  // Filter materials based on category, subcategory, and search text
  const applyFilters = useCallback(() => {
    let result = allMaterials || [];

    // Filter by category
    if (selectedCategory) {
      result = result.filter((m) => m.category === selectedCategory);
    }

    // Filter by subcategory
    if (selectedSubCategory) {
      result = result.filter((m) => m.subCategory === selectedSubCategory);
    }

    // Filter by search text
    const search = getCommonSearchTxt.trim().toLowerCase();
    if (search !== "") {
      result = result.filter((item) =>
        searchableKeys.some((key) =>
          String(item[key] || "")
            .toLowerCase()
            .includes(search),
        ),
      );
    }

    setFilteredData(result);
    // eslint-disable-next-line
  }, [allMaterials, selectedCategory, selectedSubCategory, getCommonSearchTxt]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      applyFilters();
    }, 300);

    return () => clearTimeout(timeout);
  }, [applyFilters]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      dialogClassName="modal-90w"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Material Selection
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <form className="space-y-4">
          <Row>
            <Col
              xs={12}
              md={3}
              lg={3}
              className="commTopButtonRightLeftPadding"
            >
              <ComboboxField
                label="Category"
                placeholder="Select Category"
                data={categoryData}
                id="category"
                iconClassName="dropdownIcon"
                name="category"
                code="code"
                description="description"
                getvalue={handleCategoryChange}
              />
            </Col>
            <Col
              xs={12}
              md={3}
              lg={3}
              className="commTopButtonRightLeftPadding"
            >
              <ComboboxField
                label="Sub Category"
                placeholder="Select Sub Category"
                data={subCategoryData}
                id="subCategory"
                iconClassName="dropdownIcon"
                name="subCategory"
                code="code"
                description="description"
                getvalue={handleSubCategoryChange}
              />
            </Col>

            {/* <Col
              sm={{ offset: 6, span: 6 }}
              md={{ offset: 8, span: 4 }}
              lg={{ offset: 8, span: 4 }}
              className="commLeftRightPadding"
            >
              <SearchField
                name="searchKey"
                value={getCommonSearchTxt}
                onChange={(event) => setCommonSearchTxt(event.target.value)}
                onClick={undefined}
                // onClick={handleSearchFuncApi}
              />
            </Col> */}
          </Row>

          <Row>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={() => toggleCardVisibility()}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CS</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Material Selection</span>
                        <span className="subHeaderTitle">
                          View of Material Selection{" "}
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          {/* <DataTable
                            title=""
                            columns={columns}
                            data={filteredData}
                            progressPending={loading}
                            paginationRowsPerPageOptions={
                              SupplierConstants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            onSelectedRowsChange={handleChangeCat}
                          /> */}
                          <div
                            style={{
                              minHeight: "470px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <DataTable
                              title=""
                              columns={columns}
                              data={filteredData}
                              progressPending={loading}
                              fixedHeader
                              fixedHeaderScrollHeight="430px"
                              progressComponent={
                                <div
                                  className="d-flex flex-column align-items-center justify-content-center w-100"
                                  style={{ height: "430px" }}
                                >
                                  <div
                                    className="spinner-border text-primary mb-3"
                                    role="status"
                                    style={{
                                      width: "2.5rem",
                                      height: "2.5rem",
                                    }}
                                  >
                                    <span className="visually-hidden">
                                      Loading materials...
                                    </span>
                                  </div>
                                  <span className="text-muted fw-medium">
                                    Loading materials, please wait...
                                  </span>
                                </div>
                              }
                              noDataComponent={
                                <div
                                  className="d-flex flex-column align-items-center justify-content-center w-100 text-muted"
                                  style={{ height: "430px" }}
                                >
                                  <i className="bi bi-inbox fs-2 mb-2 text-secondary"></i>
                                  <span>
                                    No materials found for the selected
                                    category.
                                  </span>
                                </div>
                              }
                              paginationRowsPerPageOptions={
                                SupplierConstants.ROW_PER_PAGE
                              }
                              pagination
                              selectableRows
                              onSelectedRowsChange={handleChangeCat}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-end">
            <Col xs={6} md={2} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={2} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={disabled}
              >
                Select
              </button>
            </Col>
            {/* <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <p className="errorMsg"> {errorMsg} </p>
            </Col> */}
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default MaterialSelectionModal;
